import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { InferType } from 'yup';
import { IBackOfEnvelopePayload } from 'views/DealDashboard/BOE/components/SlideoutForm/types';
import { formatStepOneData, formatStepTwoData, formatStepThreeData } from 'views/ProFormaSetup/helpers/formatStepData';
import { dealInputSchema } from '../DealForm/inputSchema';

export type IDealData = Omit<InferType<typeof dealInputSchema>, 'useCoordinates'> & {
    propertyType: string;
};

export interface ISignUpPayload {
    dealData: IDealData;
    boeScenario: IBackOfEnvelopePayload;
    basicInformation: ReturnType<typeof formatStepOneData>;
    development: ReturnType<typeof formatStepTwoData>;
    operations: ReturnType<typeof formatStepThreeData>;
}

export interface IDealFromSignup {
    orgId: string;
    signUpData: ISignUpPayload;
}

const createDealFromSignup = async ({ signUpData, orgId }: IDealFromSignup): Promise<IDealData> => {
    const response = await axiosInstance.post(
        `${API_ENDPOINTS.DEAL_FROM_SIGNUP(orgId)}`,
        signUpData,
    );
    return response.data;
};

export const useCreateDealFromSignup = (): UseMutationResult<
    IDealData,
    Error,
    IDealFromSignup,
    unknown
> => useMutation({
    mutationFn: createDealFromSignup,
});

export default useCreateDealFromSignup;
